package br.com.texeratx.boardgametimeapp.ui.screens.games.edit

import br.com.texeratx.boardgametimeapp.ui.screens.games.model.PlayerOwnerUI

data class EditGameState(
    // readonly (catalog-derived)
    val name: String = "",
    val imageUrl: String = "",
    val minPlayers: String = "",
    val maxPlayers: String = "",
    val duration: String = "",
    val bggUrl: String = "",

    // editable (clan-level)
    val manualUrl: String = "",
    val spotifyUrl: String = "",
    val modeId: Long? = null,
    val categoryId: Long? = null,
    val categories: List<br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameCategoryUI> = emptyList(),

    val owners: List<PlayerOwnerUI> = emptyList(),
    val selectedOwners: List<PlayerOwnerUI> = emptyList(),
    val isLoadingOwners: Boolean = false,

    val isSaving: Boolean = false,
    val error: String? = null
)
